import React, { Component } from "react";
import { Select, Button } from "../widgets";
import "./MFASettingsForm.css";

export default class MFASettingsForm extends Component {
  render() {
    return (
      <div className="mfa-settings-form-container">
        <p>Configure how you wish to manage MFA logins.</p>
        <div className="mfa-settings-form">
          <div className="field-box">
            <h6>How would you prefer to obtain the MFA code?</h6>
            <Select
              containerStyle={{ width: "300px", display: "inline-block" }}
              options={[{ value: "APP", label: "Google Authenticator (or similar)" }]}
              value={this.props.codePreference}
              onChange={this.props.onCodePreferenceChange}
              clearable={false}
            />

            <p className="google-auth-help">
              Google Authenticator is available as a free download via the{" "}
              <a
                href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Play
              </a>{" "}
              and{" "}
              <a
                href="https://itunes.apple.com/au/app/google-authenticator/id388497605?mt=8"
                target="_blank"
                rel="noopener noreferrer"
              >
                App Store
              </a>
              .
            </p>

            {this.props.saveEnabled ? (
              <div>
                <Button
                  id="mfa-settings-save"
                  type="primary"
                  icon="check"
                  onClick={this.props.onSave}
                  loading={this.props.loading}
                >
                  Update MFA Settings
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
